import { IDialog, IEditDialog } from "@serenity-is/corelib";
import DialogTypes from "./DialogTypes";

async function openDialog(this: () => Promise<{ new(): IEditDialog & IDialog }>, id: any, asPanel?: boolean) {
    var dlg = new (await this())();
    dlg.load(id, () => dlg.dialogOpen(asPanel), null);
}

const Dialogs = {
}

for (var key of Object.keys(DialogTypes)) {
    Dialogs[key] = openDialog.bind(DialogTypes[key]);
}

export default Dialogs;